<div class="container borderless">
  <div class="d-none d-md-block">
    <div class="row padding-bottom-5 d-flex card-title">
      <h3 class="mr-2">{{ envelope.title }}</h3>
    </div>
    <div class="row">
      <!-- Segmento -->
      <div>
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['fas', 'folder']">
          </fa-icon>{{ "envelope.sent.card.segment" | translate | titlecase }}:
        </span>
        <span class="text-field gray">
          {{ (envelope.segment?.name !== null && envelope.segment?.name !== undefined) ? envelope.segment?.name : ('none' | translate) }}
        </span>
      </div>
      <!-- Criado -->
      <div class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['fas', 'envelope-open-text']">
          </fa-icon>{{ "envelope.sent.card.created" | translate | titlecase }}:
        </span>

        <span class="text-expiration gray">
          {{ envelope.creationDate.datetime | date:getDateFormat() }}
        </span>
      </div>
      <!-- Documentos -->
      <div
        *ngIf="envelope.status === sentEnvelopeStatus.pending || envelope.status === sentEnvelopeStatus.onApproval || envelope.status === sentEnvelopeStatus.reproved || envelope.status === sentEnvelopeStatus.toFill"
        class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class=" margin-right-10 fa-fw inline" [icon]="['far','file-alt']">
          </fa-icon>{{ "envelope.sent.card.documents" | translate | titlecase }}:
        </span>
        <span class="text-field gray">
          {{ (envelope.files?.length || 0) | number:'2.0' }}
        </span>
      </div>
      <!-- Modificado -->
      <div *ngIf="envelope.status === sentEnvelopeStatus.completed || envelope.status === sentEnvelopeStatus.expired"
        class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-fw inline" size="sm" [icon]="['fas','edit']">
          </fa-icon>{{ "envelope.sent.card.modified" | translate | titlecase }}: &nbsp;
        </span>
        <span class="text-expiration gray">
          {{ envelope.lastModifiedDate.datetime | date:getDateFormat() }}
        </span>
      </div>
      <!-- Expiração -->
      <div *ngIf="envelope.status !== sentEnvelopeStatus.completed" class="margin-left-20">
        <span class="text-normal"
          [ngClass]="{'gray': envelope.status === sentEnvelopeStatus.pending, 'red': envelope.status === sentEnvelopeStatus.expired}">
          <fa-icon class="margin-right-10 inline" [icon]="['fas', 'hourglass-half']">
          </fa-icon>{{ "envelope.sent.card.expiration" | translate | titlecase }}:
        </span>
        <span class="text-expiration gray"
          [ngClass]="{'gray': envelope.status === sentEnvelopeStatus.pending, 'red': envelope.status === sentEnvelopeStatus.expired}"
          *ngIf="envelope.expiration">
          {{ envelope.expiration | date:getDateFormat() : 'envelope.listGrid.noExpiration' | translate | titlecase }}
        </span>
        <span class="text-expiration gray" *ngIf="!envelope.expiration">{{ 'envelope.listGrid.noExpiration' | translate
          | titlecase }}</span>
      </div>
      <!-- Assinaturas -->
      <div class="margin-left-20">
        <span class="text-normal gray" *ngIf="envelope.status === sentEnvelopeStatus.pending">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['fas', 'signature']">
          </fa-icon>{{ "envelope.sent.card.signatures" | translate | titlecase }}:
        </span>
        <span class="text-normal gray"
          *ngIf="(envelope.status === sentEnvelopeStatus.onApproval || envelope.status === sentEnvelopeStatus.reproved)">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['fas', 'signature']">
          </fa-icon>{{ "envelope.sent.card.authorizers" | translate | titlecase }}:
        </span>
        <span *ngIf="envelope.status === sentEnvelopeStatus.pending">
          <span class="text-field gray">
            {{ envelope.totalSignaturesCompleted}}/{{ envelope.totalSignatures }}
          </span>
        </span>
        <span class="text-field gray"
          *ngIf="(envelope.status === sentEnvelopeStatus.onApproval || envelope.status === sentEnvelopeStatus.reproved)">
          <span class="text-field gray">
            {{ envelope.totalAuthorizationsCompleted }}/{{ envelope.totalAuthorizers }}
          </span>
        </span>
      </div>
      <!-- Conclusão -->
      <div *ngIf="envelope.status === sentEnvelopeStatus.completed" class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-gray inline" size="sm" [icon]="['fas','check-circle']">
          </fa-icon>{{"envelope.sent.card.conclution"
          | translate | titlecase}}:&nbsp;&nbsp;
        </span>
        <span class="text-expiration gray">
          {{ envelope.conclutionDate.datetime | date:getDateFormat() }}
        </span>
      </div>
      <!-- Exclusão -->
      <div *ngIf="envelope.status === sentEnvelopeStatus.deleted" class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-gray inline" [icon]="['fas', 'times-circle']">
          </fa-icon>{{ "envelope.sent.card.excluded" | translate | titlecase }}:
        </span>
        <span class="text-expiration gray">
          {{ envelope.lastModifiedDate.datetime | date:getDateFormat() }}
        </span>
      </div>
      <div *ngIf="envelope.status === sentEnvelopeStatus.toFill" class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['far', 'file-signature']">
          </fa-icon>{{ "envelope.sent.card.responsible" | translate | titlecase }}:
        </span>
        <span class="text-expiration gray">
          {{ envelope.responsibleName }}
        </span>
      </div>
        <!-- Recusado -->
      <div *ngIf="envelope.status === sentEnvelopeStatus.rejected" class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-fw inline" [icon]="['fas', 'times-circle']">
          </fa-icon>{{ "envelope.sent.card.rejected" | translate | titlecase }}:
        </span>
        <span class="text-field">
          {{ envelope.rejectedBy }}
        </span>
      </div>
  <!-- Data de recusa -->
      <div *ngIf="envelope.status === sentEnvelopeStatus.rejected" class="margin-left-20">
        <span class="text-normal gray">
          <fa-icon class="margin-right-10 fa-gray inline" [icon]="['fas', 'calendar-times']">
          </fa-icon>{{ "envelope.sent.card.dateRejected" | translate }}:
        </span>
        <span class="text-expiration gray">
          {{ envelope.rejectedDate.datetime | date:getDateFormat() }}
        </span>
      </div>
    </div>
  </div>
</div>
